/// <reference path="../../../node_modules/sweetalert2/sweetalert2.d.ts" />
import Swal from "sweetalert2";
import "jquery";

var xhrNumber = 0;

export default function init() {
  window.addEventListener("load", function () {
    let productRange = this.document.querySelector("#productrangefilter");

    if (productRange) {
      window.onpopstate = function (e: any) {
        if (e.state) {
          $("#downloadsAppend").html(e.state.content).hide().fadeIn();

          document.title = e.state.pageTitle;

          $("#productrangefilter").val(e.state.productRange);
          $("#documenttypefilter").val(e.state.documentType);
          $("#documentlanguagefilter").val(e.state.documentLanguage);

          $(".page-link")
            .off("click")
            .click(function () {
              search($(this).data("pagenumber"), false, true);
            });
        }
      };

      $(
        "#productrangefilter, #documenttypefilter, #documentlanguagefilter"
      ).change(function () {
        search(1, false, false);
      });

      search($("#requestedPage").val(), true, false);
    }
  });

  function search(pageNumber: any, replaceState: boolean, jumpToTop: boolean) {
    let productRange = $("#productrangefilter").val();
    let documentType = $("#documenttypefilter").val();
    let documentLanguage = $("#documentlanguagefilter").val();
    let pageContentGuid = $("#pageContentGuid").val();

    if (jumpToTop === true) {
      $("html, body").animate(
        {
          scrollTop: $("#downloadsAppend").offset()?.top,
        },
        500
      );
    }

    $("#downloadsPageLoader").removeClass("d-none");

    $("#downloadsAppend").fadeOut();

    // Used for just render the last ajax call
    let seqNumber = ++xhrNumber;

    $.get("/downloadspage/downloadssearch/", {
      productRange: productRange,
      documentType: documentType,
      documentLanguage: documentLanguage,
      pageContentGuid: pageContentGuid,
      actualPage: pageNumber,
    })
      .done(function (data) {
        if (xhrNumber === seqNumber) {
          $("#downloadsAppend").html(data).hide().fadeIn();

          $(".page-link")
            .off("click")
            .click(function () {
              search($(this).data("pagenumber"), false, true);
            });

          let currentPage = $("#currentPage").val();
          let title = document.title + " - " + currentPage;

          if (!replaceState) {
            history.pushState(
              {
                content: data,
                productRange: productRange,
                documentType: documentType,
                documentLanguage: documentLanguage,
                pageTitle: title,
              },
              title,
              "?page=" +
                currentPage +
                "&productrange=" +
                productRange +
                "&documenttype=" +
                documentType +
                "&documentlanguage=" +
                documentLanguage
            );
          } else {
            history.replaceState(
              {
                content: data,
                productRange: productRange,
                documentType: documentType,
                documentLanguage: documentLanguage,
                pageTitle: title,
              },
              title,
              "?page=" +
                currentPage +
                "&productrange=" +
                productRange +
                "&documenttype=" +
                documentType +
                "&documentlanguage=" +
                documentLanguage
            );
          }
        }
      })
      .fail(function (error) {
        if (xhrNumber === seqNumber) {
          Swal.fire("Oops...", error.statusText, "error");
          $("#downloadsAppend").fadeIn();
        }
      })
      .always(function () {
        if (xhrNumber === seqNumber) {
          $("#downloadsPageLoader").addClass("d-none");
        }
      });
  }
}
init();
